import { render, staticRenderFns } from "./EditDocumentModal.vue?vue&type=template&id=4db533c6"
import script from "./EditDocumentModal.vue?vue&type=script&lang=ts"
export * from "./EditDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db533c6')) {
      api.createRecord('4db533c6', component.options)
    } else {
      api.reload('4db533c6', component.options)
    }
    module.hot.accept("./EditDocumentModal.vue?vue&type=template&id=4db533c6", function () {
      api.rerender('4db533c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/PackageDocument/Components/EditDocumentModal.vue"
export default component.exports